import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { BaseButton } from '../../components/Buttons';
import { ReactComponent as PrintOut } from '../../assets/icons/print-out.svg';
import { PdfInvoice } from '../Pdf/PdfInvoice';
import { isFirefox } from 'react-device-detect';

export const PrintButton = ({ dataBilling, pdfUrl, pdfLoading, pdfError, ...props }) => {
  const openPDF = (url) => () => {
    window.open(url, '_blank');
  };
  
  if (isFirefox) {
    const invoice = <PdfInvoice dataBilling={dataBilling} />;
    return (
      <PDFDownloadLink
        document={invoice}
        fileName={`${dataBilling.invoiceIdentify}.pdf`}
      >
        {({ loading, error }) => {
          if (error) console.error('PDF generation error:', error);
          return (
            <BaseButton 
              disabled={!!loading} 
              startIcon={<PrintOut />} 
              {...props}
            >
              {loading ? `Carregando...` : `Baixar`}
            </BaseButton>
          );
        }}
      </PDFDownloadLink>
    );
  }

  const isButtonDisabled = !!pdfLoading || !!pdfError;
  
  return (
    <BaseButton
      disabled={isButtonDisabled}
      startIcon={<PrintOut />}
      onClick={pdfError ? null : openPDF(pdfUrl)}
      {...props}
    >
      {pdfLoading ? `Carregando...` : `Imprimir`}
    </BaseButton>
  );
};
